export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-zoom/index.js
// module id = ../../../../d3-zoom/index.js
// module chunks = 4